import React from "react";
import Logo from "../components/Logo";

export default function Restricted({ reason }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        textAlign: "center",
      }}
      data-testid="restricted-page"
    >
      <div style={{ maxWidth: 460 }}>
        <Logo style={{ width: 96, marginBottom: 20, filter: "drop-shadow(0 0 24px rgba(255, 222, 22, 0.4))" }} />
        <h1 style={{ color: "#ffde16", margin: "0 0 10px", letterSpacing: 2, textTransform: "lowercase", fontSize: "clamp(1.6em, 4vw, 2.4em)" }}>
          access restricted
        </h1>
        <p style={{ color: "#fffbd4", lineHeight: 1.7, fontSize: "0.95em" }}>
          this corner of the platform isn't available to you right now. if you believe this is a
          mistake, please reach out at{" "}
          <a href="mailto:xaelserpent@gmail.com" style={{ color: "#ffde16" }}>
            xaelserpent@gmail.com
          </a>
          .
        </p>
        {reason && (
          <p style={{ marginTop: 18, fontSize: "0.75em", opacity: 0.55, fontFamily: "Courier New, monospace" }}>
            ref: {reason}
          </p>
        )}
      </div>
    </div>
  );
}
